import * as React from 'react';
import { useCallback } from 'react';
import { useIntl } from 'react-intl';
import { useSelector } from 'react-redux';
import { Dropdown } from 'semantic-ui-react';

import { localeData } from '../../locales/data';
import { StateType } from '../../reducers';
import { convertArrayFromDropdown } from '../../shared/helpers';
import { useAppDispatch } from '../../shared/services/store/useAppDispatch';

import { SelectAddProps } from './types';
import { FieldSet } from './FieldSet';
import { FormattedMessageHelper } from '../../shared/helpers/internationalization';

const SelectAddConnect = (props: SelectAddProps) => {
  const intl = useIntl();
  const dispatch = useAppDispatch();

  // @ts-ignore
  const value: any = useSelector((state: StateType) => state.getIn(props.pathValue));
  // @ts-ignore
  const errors: any = useSelector((state: StateType) => state.getIn(props.pathErrors));
  // @ts-ignore
  const options: any = useSelector((state: StateType) => state.getIn(props.pathOptions));
  // @ts-ignore
  const addOptions: any = useSelector((state: StateType) => state.getIn(props.pathAddOptions));

  const dispatchChangeField = useCallback(
    (_: any, data: any) => dispatch(props.onChangeFieldAction(data)),
    [dispatch, props.onChangeFieldAction]
  );

  const dispatchChangeOptions = useCallback((data: any) => dispatch(props.handleAddOptions(data)), [dispatch, props.handleAddOptions]);

  const handleAddOptions = (_: any, data: any) => {
    const value = data.value;
    const addOpts = addOptions.toJS();
    const concatenatedOptions = addOpts.concat({ label: value, value });
    dispatchChangeOptions(concatenatedOptions);
  };

  const setOptions = () => {
    if (!options) {
      const newValue = !value ? '' : value;
      const opts = [{ label: newValue, value: newValue }];
      dispatchChangeOptions(opts);

      return opts;
    }

    if (value && value !== '') {
      const optionExist: any = options.find((val: any) => val.get('value') === value);
      if (!optionExist) {
        const opts = options;
        const concatenatedOptions = opts.concat({ label: value, value }).toJS();
        dispatchChangeOptions(concatenatedOptions);

        return concatenatedOptions;
      } else {
        return options.toJS();
      }
    } else {
      return options.toJS();
    }
  };

  const {
    label,
    id,
    name,
    modifiers = [],
    autoFocus = false,
    tabIndex = 1,
    disabled = false,
    required = false,
    search = true,
    selection = true,
    searchInput = {},
    placeholder,
    info = '',
  } = props;

  return (
    <FieldSet id={id} label={label} required={required} modifiers={modifiers} errors={errors}>
      <>
        <Dropdown
          name={name}
          value={value}
          disabled={disabled}
          autoFocus={autoFocus}
          options={convertArrayFromDropdown(setOptions())}
          search={search}
          tabIndex={tabIndex}
          onChange={dispatchChangeField}
          selection={selection}
          className="dropdown-custom"
          searchInput={searchInput}
          onAddItem={handleAddOptions}
          allowAdditions={true}
          placeholder={intl.formatMessage({ id: placeholder, defaultMessage: localeData.en[placeholder] })}
        />
        {info !== '' && (
          <div className="info_small">
            <FormattedMessageHelper tagName="span" id={info} defaultMessage={localeData.en[info]} />
          </div>
        )}
      </>
    </FieldSet>
  );
};

export default SelectAddConnect;
